import { render } from "./Indications.vue?vue&type=template&id=2cec417d&scoped=true"
import script from "./Indications.vue?vue&type=script&lang=js"
export * from "./Indications.vue?vue&type=script&lang=js"

import "./Indications.vue?vue&type=style&index=0&id=2cec417d&scoped=true&lang=css"

import exportComponent from "D:\\Dev\\devine-mot\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cec417d"]])

export default __exports__